var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m2 wrapper wrapper--default"},[_c('h3',{staticClass:"text-center m-2"},[_vm._v("Soorten - "+_vm._s(_vm.bu))]),_c('hr'),(_vm.loading)?_c('Loading'):_c('div',{staticClass:"p-2"},[_c('div',{staticClass:"flex center"},[_c('PurchaseDuoTable',{attrs:{"table_data":_vm.kinds,"table_data_totals":_vm.totals,"bu":_vm.bu}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }